async function graphQLMetaObjectsControlsCall(type) {
  var tokenData = JSON.parse(localStorage['agchimpToken']);

  var settings = {
    url: "https://agchimpapi.azurewebsites.net/api/Shopify/graph",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + tokenData.token
    },
    data: JSON.stringify({
      query: `query GetWeeds {
  metaobjects(type: "`+type+`", first: 100) {
    edges {
      node {
        id
        handle
      fields {
  key
  value
  reference {
    ... on MediaImage {
      image {
        url
        altText
      }
    }
  }
  references(first: 20) {
    edges {
      node {
        ... on Product {
          id
        }
      }
    }
  }
}

      }
    }
  }
}
      `
    })
  };

//   console.log(settings);

  // 🔑 THIS IS THE FIX
  return $.ajax(settings);
}
